import { webTypeApiUrl } from "@/constants/webTypeApiUrl";


export const SocialPairedBasisInfoHandler = {
  MyFunction: function (param) {
    alert(param);
  },
  //取得業務員資料
  GetStaffInfo: function (staffid) {
    var url = webTypeApiUrl.MessageAPI + "/SocialLeadPairedBasisInfo/GetStaffInfo";
    var staff = [];
    $.ajax({
      url: url,
      type: "post",
      async: false,
      data: {
        staffId: staffid
      },
      dataType: "json",
      success: function (data) {
        staff = data;
      },
      error: function (a, b, c) { }
    });

    return staff
  },
  //取得客戶頭像資料
  GetSocialLeadPairedBasisInfo: function (socialLeadId, staffid) {
    var url = webTypeApiUrl.MessageAPI + "/SocialLeadPairedBasisInfo/GetSocialLeadPairedBasisInfo";
    var pairedBasisInfo = [];
    $.ajax({
      url: url,
      type: "post",
      async: false,
      data: {
        socialLeadId: socialLeadId,
        staffId: staffid
      },
      dataType: "json",
      success: function (data) {
        pairedBasisInfo = data;
      },
      error: function (a, b, c) { }
    });

    return pairedBasisInfo
  },
  //取得SocialLead
  GetSocialLead: function (socialLeadId, staffid) {
    var url = webTypeApiUrl.MessageAPI + "/SocialLeadPairedBasisInfo/GetSocialLead";
    var socialLead = [];
    $.ajax({
      url: url,
      type: "post",
      async: false,
      data: {
        socialLeadId: socialLeadId,
        staffId: staffid
      },
      dataType: "json",
      success: function (data) {
        socialLead = data;
      },
      error: function (a, b, c) { }
    });

    return socialLead;
  },
  //儲存客戶頭像資料
  SaveSocialLeadPairedBasisInfo: function (model, staffid) {
    var url = webTypeApiUrl.MessageAPI + "/SocialLeadPairedBasisInfo/SaveSocialLeadPairedBasisInfo";
    $.ajax({
      url: url,
      type: "post",
      async: false,
      data: {
        model: model,
        tagName: model.tagName,
        classdata: model.classdata,
        staffId: staffid
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        } else {
          alert("儲存成功");
        }
      },
      error: function (a, b, c) { }
    });
  },
  HasPermission: function (staffid, permissionId) {
    var url = webTypeApiUrl.MessageAPI + "/SocialLeadPairedBasisInfo/HasPermission";
    var resp = false;
    $.ajax({
      url: url,
      type: "post",
      async: false,
      data: {
        staffId: staffid,
        permissionId: permissionId
      },
      dataType: "json",
      success: function (data) {
        resp = data;
      },
      error: function (a, b, c) { }
    });

    return resp
  },
};



// WEBPACK FOOTER //
// ./src/handler/SocialPairedBasisInfoHandler.js